var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 73,
    viewBox: "0 0 40 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5324 32.0389C12.613 29.6461 9.7446 27.1722 9.7446 23.3194C9.7446 18.8989 13.7132 15.8167 20.3536 15.8167C27.3477 15.8167 29.9411 19.2639 30.1768 24.3333H38.8605C38.5855 17.3578 34.4597 10.95 26.2475 8.88167V0H14.4597V8.76C6.83693 10.4633 0.707268 15.5733 0.707268 23.4006C0.707268 32.7689 8.21218 37.4328 19.1749 40.15C28.998 42.5833 30.9627 46.1522 30.9627 49.9239C30.9627 52.7222 29.0373 57.1833 20.3536 57.1833C12.2593 57.1833 9.07662 53.4522 8.6444 48.6667H0C0.471513 57.5483 6.91552 62.5367 14.4597 64.1994V73H26.2475V64.2806C33.9096 62.78 40 58.1972 40 49.8833C40 38.3656 30.4519 34.4317 21.5324 32.0389Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.fe2b3bdab780e2b2a79cadb2d725a5b3.svg";
export { ForwardRef as ReactComponent };